import { apiClient } from './client';
import { categoriesArraySchema, categorySchema } from './schemas';
import {Category, CreateCategoryData, TransactionType, UpdateCategoryData} from './types';

export const categoriesApi = {
  async getAll(type?: TransactionType): Promise<Category[]> {
    const endpoint = type ? `/categories?type=${type}` : '/categories';
    return apiClient.get<Category[]>(endpoint, categoriesArraySchema);
  },

  async create(data: CreateCategoryData): Promise<Category> {
    return apiClient.post<Category>('/categories', data, categorySchema);
  },

  async update(id: string, patch: UpdateCategoryData): Promise<Category> {
    return apiClient.put<Category>(`/categories/${id}`, patch, categorySchema);
  }
};
